import React from 'react';
import { Tree, Input, Dropdown, Menu, Icon } from 'antd';
import { addCtnCommonAttribute } from "./SgiCtnComm"
import { uuid } from "rt-sd-common/sgiCommon/sgiCommon";
import { SgiEventHandler } from './SgiEventHandler';
import { sgiTreeBaseFun, sgiTreeNodeFun } from "./SgiTreeBaseFun"
import { sgiLogger } from 'rt-sd-common/sgiCommon/sgiLogger';
import { StandardCode } from 'rt-sd-common/sgiFactory/StandardCode';
import { getPropsFromItem, toCallSi } from './SgiCompComm';
import sgiConstants from 'rt-sd-common/sgiConstants/sgiConstants';
import { getConstByKey } from './sgiBaseComp/SgiCommon';
import { element } from 'prop-types';

const TreeNode = Tree.TreeNode;
const Search = Input.Search;
const MenuItem = Menu.Item;
const SubMenu = Menu.SubMenu;

const treeConfConstant = {
    childrenName: 'cldSet',
    indexKey: "_index",
    key: '_key',
    // pKey: '_pKey'
}


const menuStyle = {
    position: 'relative',
    margin: 0,
    padding: '4px 0',
    textAlign: 'left',
    listStyleType: 'none',
    backgroundColor: '#fff',
    backgroundClip: 'padding-box',
    borderRadius: '4px',
    outline: 'none',
    boxShadow: '0 2px 8px rgba(0,0,0,.15)',
    'title:hover': {
        backgroudColor: '#e6f7ff'
    }
    // 'title:hover':'backgroud-color : #e6f7ff'
}

const SubMenuStyle = {
    clear: 'both',
    margin: 0,
    padding: '5px 12px',
    color: 'rgba(0,0,0,.65)',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '22px',
    whiteSpace: 'nowrap',
    cursor: 'pointer',
    height: 'auto',
    transition: 'all .3s'
}

class SgiTree extends React.Component {

    static defaultProps = {
    };  // 注意这里有分号
    static propTypes = {
    };  // 注意这里有分号


    constructor(props) {
        super(props);
        //初始化state
        this.state = {
            checkable: false,
            multiple: false,
            loading: false,  //加载属性
            expandedKeys: [], //展开keys
            selectedKeys: [], //选中keys
            checkedKeys: [],
            displayField: '',
            autoExpandParent: false, //自动展开父节点
            childrenName: treeConfConstant.childrenName,
            indexKey: treeConfConstant.indexKey,
            key: treeConfConstant.key,
            // pKey: treeConfConstant.pKey,

            // treeProps: { style: { height: '100%' } }, //树基础属性
            treeProps: { style: {} }, //树基础属性
            treeData: [], //树的显示数据
            // treeCheckData: [], //勾选版树结构json数据
            store: [],
            insName: '',
            functions: {},
            selectedNodes: [], //已选中/勾选节点list
            checkedNodes: [], //已选中/check节点list
            keysTreeNode: {}, //存储所有的treenode信息

            isSearch: false,
            searchValue: '',
            // autoExpandParent: true,

            menuItems: [],// 右键定义菜单使用 菜单组件数组
            customMenuItems: [],// 右键自定义带单使用
            menuFuns: {},//存放菜单点击事件

            rightClickNodeTreeItem: {
                pageX: "",
                pageY: "",
                id: "",
                categoryName: ""
            },
            ContextMenuVisible: "none",
            cstmConst: {}//自定义解析属性

        };
    }

    /**
     * 动态添加自定义菜单
     * @param {*} customMenuItems 例子：[{icon:'',mnCLsn:'',te:''}]
     * @param {*} flag 
     */
    addCustomMenuItems(customMenuItems, flag) {
        // 动态
        if (!customMenuItems) {
            return;
        }

        customMenuItems.forEach(element => {
            element.c = uuid(8);
        });

        //true
        if (flag) {
            this.state.customMenuItems.push(...customMenuItems);
        } else {
            this.state.customMenuItems = customMenuItems;
        }

        this.setState({ loading: false });
    }

    //根据id获取数据
    /**
     * 根据唯一标示，从数据中找到相应的组件数据
     * @param {*} rootChildren
     * @param {*} dnd_id
     */
    findNodeByKey = function (rootChildren, key) {
        if (!rootChildren) {
            rootChildren = this.state.treeData;
        }
        if (!key) {
            return;
        }
        for (let i = 0; i < rootChildren.length; i++) {
            let tmpNode = rootChildren[i];
            let tmp_dnd_id = tmpNode[this.state.key];
            if (key === tmp_dnd_id) {
                return tmpNode;
            }
            if (tmpNode[this.state.childrenName] && tmpNode[this.state.childrenName].length > 0) {
                let result = this.findNodeByKey(tmpNode[this.state.childrenName], key);
                if (result) return result;
            }
        }
    }

    /**
     * 根据描述创建文本框
     * @param {父组件} parentModule
     * @param {组件描述} moduleDesc
     * @param {绑定实例ID} bdInst
     * @param {对象工厂} objFct
     * @param {make类型} type
     */
    tree_mk(parentModule, moduleDesc, bdInst, objFct, type) {

        //获取需要展示的数据信息
        if (!moduleDesc) {
            return;
        }
        //绑定数据，创建表格store 搜索条、翻页控件需要使用该信息，所以先创建
        var tableStore = this.getTreeData(moduleDesc, objFct);
        this.state.treeData = tableStore;
        this.state.insName = getConstByKey(this, moduleDesc.insName);//绑定实例名
        //显示信息
        this.state.displayField = moduleDesc.c ? moduleDesc.c : 'te';
        //转换基础属性
        this.AddTreeAttribute(moduleDesc, this.state.treeProps);
        //转换form公共属性
        addCtnCommonAttribute(this, moduleDesc, this.state.treeProps);
        //绑定事件
        this.bindEvent(moduleDesc, this.state.treeProps, this.state.functions, type);
        // 右键菜单
        this.createMenuItems(moduleDesc);
        // 自定义解析属性
        this.setCstmConst(moduleDesc)
    }

    setCstmConst(moduleDesc) {
        if (moduleDesc.iconKey) {
            this.state.cstmConst[moduleDesc.iconKey] = "icon"
        }
        if (moduleDesc.checkKey) {
            this.state.cstmConst[moduleDesc.checkKey] = "checked";
        }
    }

    /**
     * 构建右键菜单
     * @param {object} moduleDesc 描述参数
     */
    createMenuItems(moduleDesc) {
        let rghtMenus;
        let mnId = moduleDesc.mnId;
        if (mnId) {// 优先标准代码
            rghtMenus = StandardCode.getSC(mnId);
        } else {
            rghtMenus = moduleDesc.rghtMenus;
        }
        // 构建菜单数组
        if (rghtMenus && rghtMenus.length > 0) {
            // this.state.menuItems = <Menu onClick={this.menuOnClick}>{this.convertMenus(rghtMenus)}</Menu>
            // this.state.menuItems = this.convertMenus(rghtMenus);
            this.state.menuItems = rghtMenus;
        } else {
            this.state.menuItems = null;
        }
    }
    /**
     * 递归创建菜单
     * @param {Array} menuItems 菜单项数组
     */
    convertMenus(menuItems, objFct, record, treeNode) {
        return menuItems.map(item => {
            let key = item.c;
            if (!key) key = item.c = uuid(8);

            let mnCLsn = item.mnCLsn;
            if (mnCLsn) {
                let $mnCLsn;
                try {
                    if (typeof (mnCLsn) == 'string') {
                        $mnCLsn = new Function("module", "objFct", "record", "treeNode", mnCLsn);
                    } else {
                        $mnCLsn = mnCLsn;
                    }
                } catch (error) {
                    sgiLogger.eventErr(error);
                }
                this.state.menuFuns[key] = $mnCLsn;
            }

            //隐藏或只读选择
            let readHideSel = item.readHideSel;

            //隐藏或只读 函数
            let readHideLsn = item.readHideLsn;
            let readHideFlag = true;
            if (readHideLsn) {
                let $readHideLsn;
                try {
                    $readHideLsn = new Function("module", "objFct", "record", "treeNode", readHideLsn);
                    readHideFlag = $readHideLsn(this, objFct, record, treeNode);
                } catch (error) {
                    sgiLogger.eventErr(error);
                }
            }


            //是否有图标
            const icon = item.icon;
            let itemTe;
            if (icon) {
                itemTe = <span>
                    <Icon type={icon} />
                    <span>{item.te}</span>
                </span>
            } else {
                itemTe = item.te;
            }

            if (readHideFlag) {
                let cldSet = item.cldSet;
                if (cldSet && cldSet.length > 0) {
                    return <SubMenu style={SubMenuStyle} key={key} itemData={item} title={item.te}>{this.convertMenus(cldSet)}</SubMenu>
                }
                return <MenuItem style={SubMenuStyle} key={key} itemData={item}>{itemTe}</MenuItem>;
            } else {
                if (readHideSel == "hide") {

                } else {
                    return <MenuItem disabled style={SubMenuStyle} key={key} itemData={item}>{itemTe}</MenuItem>;;
                }
            }
            // return <MenuItem style={SubMenuStyle} key={key} itemData={item}>{item.te}</MenuItem>
            // let cldSet = item.cldSet;
            // if (cldSet && cldSet.length > 0) {
            //     return <SubMenu style={SubMenuStyle} key={key} itemData={item} title={item.te}>{this.convertMenus(cldSet)}</SubMenu>
            // }
            // return <MenuItem style={SubMenuStyle} key={key} itemData={item}>{item.te}</MenuItem>
        });
    }

    /**
     * 绑定事件
     * @param {*} moduleDesc
     * @param {*} treeProps
     */
    bindEvent(moduleDesc, treeProps, functions, type) {
        // 用户自定义点击事件
        var iCLsn = moduleDesc.iCLsn;
        if (iCLsn && type != 'dnd') {
            var $iCLsn;
            try {
                $iCLsn = new Function("module", "objFct", "record", "treeNode", "e", iCLsn);
            } catch (error) {
                sgiLogger.eventErr(error);
            }

            // functions.onSelect = $iCLsn;
            functions.onSelect = (module, objFct, record, treeNode, e) => {
                $iCLsn(module, objFct, record, treeNode, e)
                // 调用服务接口配置
                toCallSi(moduleDesc, this.props.objFct)
            };
        }
        treeProps.onSelect = SgiEventHandler.itemclick.bind(this);

        // 双击事件
        var dbCLsn = moduleDesc.dbCLsn;
        if (dbCLsn && type != 'dnd') {
            var $dbCLsn;
            try {
                $dbCLsn = new Function("module", "objFct", "record", "treeNode", "node", "e", dbCLsn);
            } catch (error) {
                sgiLogger.eventErr(error);
            }
            functions.onDoubleClick = $dbCLsn;
        }
        treeProps.onDoubleClick = SgiEventHandler.itemDoubleClick.bind(this);

        // 右键点击事件
        var rCLsn = moduleDesc.rCLsn;
        if (rCLsn && type != 'dnd') {
            var $rCLsn;
            try {
                $rCLsn = new Function("module", "objFct", "record", "treeNode", rCLsn);
            } catch (error) {
                sgiLogger.eventErr(error);
            }
            functions.onRightClick = $rCLsn;
        }
        treeProps.onRightClick = SgiEventHandler.itemRightClick.bind(this);

        // 勾选事件(ndIsChk:是否可以多选，ChLsn:check事件)
        let ndIsChk = moduleDesc.ndIsChk;
        let ChLsn = moduleDesc.ChLsn;
        if (ndIsChk && ChLsn) {
            let $ChLsn;
            try {
                $ChLsn = new Function("module", "objFct", "record", "treeNode", "checked", "e", ChLsn);
            } catch (error) {
                sgiLogger.eventErr(error);
            }

            functions.onCheck = $ChLsn;
        }

        // 拖拽释放事件
        let onDrp = moduleDesc.onDrp;
        if (onDrp) {
            let $onDrp;
            try {
                $onDrp = new Function("module", "objFct", "record", "treeNode", onDrp);
            } catch (error) {
                sgiLogger.eventErr(error);
            }

            functions.onDrop = $onDrp;
        }

        treeProps.onExpand = (expandedKeys) => {
            this.state.expandedKeys = expandedKeys;
            this.state.autoExpandParent = false;
            this.setState({ loading: false });

        }

    }

    /**
    * 创建表格绑定store
    * @param {*} moduleDesc
    * @param {*} objFct
    * @param {*} ClmDes
    */
    getTreeData(moduleDesc, objFct) {
        //取得绑定实例名
        var insName = getConstByKey(this, moduleDesc.insName); //绑定实例名
        var tData;
        //取得绑定类名`  var tData = [];
        if (insName && objFct) {
            tData = objFct.get(insName);
        }
        if (!tData) {
            return [];
        }
        return tData;
    }

    onCheck = (checkedKeys, e) => {
        // tool.sgiLogger.log('onCheck checkedKeys:', checkedKeys);
        // tool.sgiLogger.log('onCheck e:', e);
        this.state.checkedNodes = [];
        e.checkedNodes.forEach(element => {
            this.state.checkedNodes.push(element.props.itemData);
            element.props.itemData[sgiConstants.checked] = true;//同步到数据
        })
        if (!e.checked) {//取消勾选
            unCheckAll(e.node.props.itemData);
        }
        // this.state.selectedKeys = checkedKeys;
        this.state.checkedKeys = checkedKeys;
        // this.state.treeProps.onSelect(checkedKeys, e);
        this.setState({ loading: false });

        SgiEventHandler.itemCheck.call(this, checkedKeys, e);

        // 取消所有子节点勾选（数据）
        function unCheckAll(item) {
            if (!item) return;
            item[sgiConstants.checked] = false;
            if (item.cldSet && item.cldSet.length > 0) {
                item.cldSet.forEach((cld, index, arr) => {
                    unCheckAll(cld);
                });
            }
        }
    }

    /**
     * 创建树视图
     */
    AddTreeAttribute(moduleDesc, treeProps) {

        // treeProps.checkStrictly = true; //父子节点点击分开
        if (moduleDesc.ndisLine) {
            treeProps.showLine = true; //树节点是否连线
        } else {
            treeProps.showLine = false; //树节点是否连线
        }
        if (moduleDesc.ndIsChk) {
            // treeProps.checkable = true; // 树节点是否可选
            // treeProps.multiple = true;
            this.state.checkable = true;
            // this.state.multiple = true;
        } else {
            // treeProps.checkable = false; // 树节点是否可选
            // treeProps.multiple = false;
            this.state.checkable = false;
            // this.state.multiple = false;
        }
        if (moduleDesc.ndIsDg) {
            treeProps.draggable = true; // 树节点是否可拖拽
        } else {
            treeProps.draggable = false; // 树节点是否可拖拽
        }

        // 即时搜索
        const isSearch = moduleDesc.isSearch;
        this.state.isSearch = !!isSearch;

        // clpDrt:"top", // 面板的折叠方向
        // clpd:false, // 面板初始时的折叠状态
        // disCustom:false, //只显示自定义菜单
        // isClp:false, // 面板是否可以折叠
        // isClpFst:true, // 是否面板展开或收缩的顺序
        // isCls:false, // 面板是否可以关闭
        // isFrm:false, // 面板是否填充
        // isHClpTl:false, // 是否显示折叠按钮
        // isMsMu:false, //使用右键菜单
        // isTlb:false, //显示工具条
        // isttlClp:false, // 是否单击面板头部折叠
        // tlbIsTtl:true, //显示标题
        // ttlAlg:"top", // 面板标题位置
        // ttlAlgn:"left", // 面板标题对齐方式
        // selFirst:false, //初始化后选择首行
        // 可设置默认选中的树节点：defaultSelectedKeys，（受控）设置选中的树节点：selectedKeys
    }

    // 定义树节点对象，追加常用方法
    fitTreeNodes = (data = []) => {
        if (!data || !(data instanceof Array)) {
            return;
        }
        return data.map((item, index) => {
            if (!item || typeof item != "object") return;
            const { searchValue, childrenName, displayField, key, indexKey, menuItems } = this.state;
            //因为树的key很重要，不能重复，数据中可能会有重复的key，所以检查是否有重复的key如果有，重新生成一个
            if (!item[key]) {
                item[key] = uuid(6);
            }
            item[indexKey] = index + 1;

            // if (this.state.keysTreeNode[item[key]]) { //存在重新生成一个 不存在添加进去 理论不会存在
            //     item[key] = uuid(6);
            // }

            //根据数据中 checked属性为true，默认选中
            if ((item.checked || item[sgiConstants.checked]) && this.state.checkedKeys.indexOf(item[key]) < 0) {
                this.state.checkedKeys.push(item[key]);
                this.state.checkedNodes.push(item);
                delete item.checked;
            }

            // 表达式解析，约定表达式格式【exp:表达式】，表达式接收参数item，例如："exp:item.te||item.n"或者"exp:item.ctlN+'_'+item.te"
            let showTitle;
            if (displayField.indexOf("exp:") > -1) {
                showTitle = eval(`(${displayField.replace("exp:", "")})`);
            } else {
                showTitle = item[displayField];
            }

            // const showTitle = item[displayField];
            let searchIndex, beforeStr, afterStr;
            if (showTitle) {
                searchIndex = showTitle.indexOf(searchValue);
                beforeStr = showTitle.substr(0, searchIndex);
                afterStr = showTitle.substr(searchIndex + searchValue.length);
            } else {
                searchIndex = -1;
            }
            let title = searchIndex > -1 ? (
                <span>
                    {beforeStr}
                    <span style={{ color: '#f50' }}>{searchValue}</span>
                    {afterStr}
                </span>
            ) : <span>{showTitle}</span>;



            // // // 右键菜单
            // if (menuItems && menuItems.length) {
            //     title = <Dropdown
            //         overlay={<Menu onClick={SgiEventHandler.menuOnClick.bind(this, item)}>{this.state.menuItems}</Menu>}
            //         trigger={['contextMenu']} itemData={item} visible={this.state.ContextMenuVisible} onVisibleChange={this.onVisibleChange}>
            //         {title}
            //     </Dropdown>;
            // }

            let currentNode;
            if (item[childrenName] && item[childrenName].length) {
                currentNode = <TreeNode itemData={item} tree={this} key={item[key]} {...sgiTreeNodeFun} title={title} {...getPropsFromItem(item, this.state.cstmConst)}>
                    {this.fitTreeNodes(item[childrenName])}</TreeNode>
                currentNode.props.children.forEach(element => {
                    element.props.parentNode = currentNode;
                });
                this.state.keysTreeNode[item[key]] = currentNode; //统一存起来
                return currentNode;
            }
            let LeafTreeNode = <TreeNode itemData={item} tree={this} key={item[key]} {...sgiTreeNodeFun} title={title} isLeaf {...getPropsFromItem(item, this.state.cstmConst)} />;
            this.state.keysTreeNode[item[key]] = LeafTreeNode; //统一存起来
            return LeafTreeNode;
        }).filter(element => element)
    };

    refresh = () => {
        this.loaded = false;
        this.setState({ loading: false });
    }

    createTreeStore() {
        //弄这个 keystreeNode 主要记录层级关系
        this.state.keysTreeNode = {};
        this.state.store = this.fitTreeNodes(this.state.treeData, null);
    }

    onDragEnter = (info) => {
        tool.sgiLogger.log("onDragEnter info:", info);
        // expandedKeys 需要受控时设置
        this.setState({
            expandedKeys: info.expandedKeys,
        });
    }

    onDrop = (info) => {
        tool.sgiLogger.log("onDrop info:", info);
        const dropKey = info.node.props.eventKey;
        const dragKey = info.dragNode.props.eventKey;
        const dropPos = info.node.props.pos.split('-');
        const dropPosition = info.dropPosition - Number(dropPos[dropPos.length - 1]);
        // tool.sgiLogger.log('dropKey :', dropKey);
        // tool.sgiLogger.log('dragKey :', dragKey);
        // tool.sgiLogger.log('dropPos :', dropPos);
        // tool.sgiLogger.log('dropPosition :', dropPosition);

        const loop = (data, key, callback) => {
            data.forEach((item, index, arr) => {
                if (item[treeConfConstant.key] === key) {
                    return callback(item, index, arr);
                }
                if (item[treeConfConstant.childrenName]) {
                    return loop(item[treeConfConstant.childrenName], key, callback);
                }
            });
        };
        // const data = [...this.state.treeData];
        let data = this.state.treeData;

        // Find dragObject
        let dragObj;
        loop(data, dragKey, (item, index, arr) => {
            arr.splice(index, 1);
            dragObj = item;
        });

        if (!info.dropToGap) {
            // Drop on the content
            loop(data, dropKey, (item) => {
                item[treeConfConstant.childrenName] = item[treeConfConstant.childrenName] || [];
                // where to insert 示例添加到尾部，可以是随意位置
                item[treeConfConstant.childrenName].push(dragObj);
            });
        } else if (
            (info.node.props.children || []).length > 0 // Has children
            && info.node.props.expanded // Is expanded
            && dropPosition === 1 // On the bottom gap
        ) {
            loop(data, dropKey, (item) => {
                item[treeConfConstant.childrenName] = item[treeConfConstant.childrenName] || [];
                // where to insert 示例添加到尾部，可以是随意位置
                item[treeConfConstant.childrenName].unshift(dragObj);
            });
        } else {
            let ar;
            let i;
            loop(data, dropKey, (item, index, arr) => {
                ar = arr;
                i = index;
            });
            if (dropPosition === -1) {
                ar.splice(i, 0, dragObj);
            } else {
                ar.splice(i + 1, 0, dragObj);
            }
        }

        // this.state.treeData = data;
        this.createTreeStore();
        this.setState({});

        // 修改数据
        var { parentModule, moduleDesc, bdInst, objFct, type } = this.props;
        var insName = getConstByKey(this, moduleDesc.insName); //绑定实例名
        if (insName && objFct) {
            objFct.set(insName, data);
        }

        // 自定义释放事件
        let cstmOnDrop = this.state.functions.onDrop;
        if (cstmOnDrop && typeof cstmOnDrop === "function") cstmOnDrop(this, objFct, dragObj, info.dragNode);
    }

    testEvent(e, e2) {
        tool.sgiLogger.log('testEvent e:', e);
        tool.sgiLogger.log('testEvent e2:', e2);
    }

    getParentKey = (key, tree) => {
        tree = tree || this.state.treeData || [];
        const { childrenName } = this.state;
        let parentKey;
        for (let i = 0; i < tree.length; i++) {
            const node = tree[i];
            if (node[childrenName]) {
                if (node[childrenName].some(item => item[this.state.key] === key)) {
                    parentKey = node[this.state.key];
                } else if (this.getParentKey(key, node[childrenName])) {
                    parentKey = this.getParentKey(key, node[childrenName]);
                }
            }
        }
        return parentKey;
    };
    cvtTreeDataToList = (treeData) => {
        let list = [];
        list.push(...treeData);
        treeData.forEach(item => {
            if (item[this.state.childrenName]) {
                list.push(...this.cvtTreeDataToList(item[this.state.childrenName]));
            }
        });
        return list;
    };
    searchOnChange = (e) => {
        const value = e.target.value;
        const expandedKeys = this.cvtTreeDataToList(this.state.treeData).map((item) => {
            if (item[this.state.displayField].indexOf(value) > -1) {
                return this.getParentKey(item[this.state.key]);
            }
            return null;
        }).filter((item, i, self) => item && self.indexOf(item) === i);

        this.state.expandedKeys = expandedKeys;
        this.state.searchValue = value;
        this.state.autoExpandParent = true;
        this.createTreeStore();
        this.setState({});
    }

    onLoaded = (loadedKeys, { event, node }) => {
        // tool.sgiLogger.log("onLoaded");
        // tool.sgiLogger.log('loadedKeys :', loadedKeys);
        // tool.sgiLogger.log('event :', event);
        // tool.sgiLogger.log('node :', node);
    }

    // 自定义右键菜单内容
    getNodeTreeRightClickMenu = () => {

        var { objFct } = this.props;

        //右键是否显示 标示 
        if (this.state.ContextMenuVisible) {
            return;
        }

        const allMenuItems = (this.state.menuItems || []).concat(this.state.customMenuItems);
        // this.state.menuItems.push(...this.state.customMenuItems);

        //菜单项是否存在
        // this.state.menuItems = this.convertMenus(rghtMenus);
        if (!allMenuItems || allMenuItems.length < 1) {
            return;
        }

        const { pageX, pageY, record, treeNode } = { ...this.state.rightClickNodeTreeItem };
        const tmpStyle = {
            ...menuStyle,
            position: "fixed",
            left: `${pageX}px`,
            top: `${pageY}px`,
            // margin: 0
        };
        const menu = (
            <Menu style={{ ...tmpStyle, display: this.state.ContextMenuVisible }} onMouseLeave={() => {
                this.setState({ ContextMenuVisible: "none" });
            }} onClick={SgiEventHandler.menuOnClick.bind(this, record)}>{this.convertMenus(allMenuItems, objFct, record, treeNode)}</Menu>
        );
        return this.state.rightClickNodeTreeItem == null ? "" : menu;
    };

    //渲染并返回一个虚拟DOM
    render = function () {

        if (!this.loaded) {
            var { parentModule, moduleDesc, bdInst, objFct, type } = this.props;
            //组装属性
            this.tree_mk(parentModule, moduleDesc, bdInst, objFct, type);
            this.loaded = true;
            this.createTreeStore();
        }

        return (
            <div>
                {(this.state.isSearch && this.state.store.length > 0) ? <Search style={{ width: this.state.treeProps.style.width }} placeholder="Search" onChange={this.searchOnChange} /> : null}
                <Tree {...this.state.treeProps}
                    checkable={this.state.checkable}
                    multiple={this.state.multiple}
                    selectedKeys={this.state.selectedKeys}
                    onCheck={this.onCheck}
                    checkedKeys={this.state.checkedKeys}
                    defaultCheckedKeys={this.state.checkedKeys}
                    expandedKeys={this.state.expandedKeys}
                    autoExpandParent={this.state.autoExpandParent}
                    onDragEnter={this.onDragEnter}
                    onDrop={this.onDrop}
                    onLoaded={this.onLoaded}
                    showIcon>
                    {this.state.store}
                </Tree>
                {this.getNodeTreeRightClickMenu()}
            </div>
        );
    }
}

//给类添加公共方法
Object.assign(SgiTree.prototype, sgiTreeBaseFun);

export { SgiTree };
export default SgiTree;



// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/SgiTree.js